// var now = +new Date();

// initial state
export const state = {
    // GUI
    navExpanderOpen: false, // The Hamburger in mobile navigation menu

    // reference books
    /* global FRS_CAMPAIGN */
    campaign: {
        short_url: FRS_CAMPAIGN,
        name: 'New Fund Raisers, Ltd. Website'
    },
    'products': {
        'regimental-red-brick': [
            {
                'description': '4" x 8" BRICK',
                'material': 'REGIMENTAL RED',
                'ui_classes': ['paver', 'p4x8', 'p4x8regimental-red'],
                'max_characters': 16,
                'max_lines': 3,
                'item_image_blank': 'iyb4x8regredbrick.png'
            },
            {
                'description': '8" x 8" BRICK',
                'material': 'REGIMENTAL RED',
                'ui_classes': ['paver', 'p8x8', 'p8x8regimental-red'],
                'max_characters': 16,
                'max_lines': 6,
                'item_image_blank': 'iyb8x8regredbrick.png'
            }
        ],
        'claret-full-range-brick': [
            {
                'description': '4" x 8" BRICK',
                'material': 'CLARET FULL RANGE',
                'ui_classes': ['paver', 'p4x8', 'p4x8claret'],
                'max_characters': 16,
                'max_lines': 3,
                'item_image_blank': 'iyb4x8claretbrick.png'
            },
            {
                'description': '8" x 8" BRICK',
                'material': 'CLARET FULL RANGE',
                'ui_classes': ['paver', 'p8x8', 'p8x8claret'],
                'max_characters': 16,
                'max_lines': 6,
                'item_image_blank': 'iyb8x8claretbrick.png'
            }
        ],
        'landmark-gray-brick': [
            {
                'description': '4" x 8" BRICK',
                'material': 'LANDMARK GRAY',
                'ui_classes': ['paver', 'p4x8', 'p4x8landgray'],
                'max_characters': 16,
                'max_lines': 3,
                'item_image_blank': 'iyb4x8landgraybrick.png'
            },
            {
                'description': '8" x 8" BRICK',
                'material': 'LANDMARK GRAY',
                'ui_classes': ['paver', 'p8x8', 'p8x8landgray'],
                'max_characters': 16,
                'max_lines': 6,
                'item_image_blank': 'iyb8x8landgraybrick.png'
            }
        ],
        'medium-ironspot-brick': [
            {
                'description': '4" x 8" BRICK',
                'material': 'MEDIUM IRONSPOT',
                'ui_classes': ['paver', 'p4x8', 'p4x8ironspot'],
                'max_characters': 16,
                'max_lines': 3,
                'item_image_blank': 'iyb4x8medironbrick.png'
            },
            {
                'description': '8" x 8" BRICK',
                'material': 'MEDIUM IRONSPOT',
                'ui_classes': ['paver', 'p8x8', 'p8x8ironspot'],
                'max_characters': 16,
                'max_lines': 6,
                'item_image_blank': 'iyb8x8medironbrick.png'
            }
        ],
        'mesabi-granite-brick': [
            {
                'description': '12" x 12" BRICK',
                'material': 'MESABI GRANITE',
                'ui_classes': ['paver', 'p8x8', 'p12x12blackgranite'],
                'max_characters': 20,
                'max_lines': 10,
                'item_image_blank': 'iyb12x12granitebrick.png'
            }
        ],
        'frs-black-granite-brick': [
            {
                'description': '4" x 8" BRICK',
                'material': 'FRS BLACK GRANITE',
                'ui_classes': ['paver', 'p4x8', 'p4x8blackgranite'],
                'max_characters': 16,
                'max_lines': 3,
                'item_image_blank': 'iyb4x8granitebrick.png'
            },
            {
                'description': '8" x 8" BRICK',
                'material': 'FRS BLACK GRANITE',
                'ui_classes': ['paver', 'p8x8', 'p8x8blackgranite'],
                'max_characters': 16,
                'max_lines': 6,
                'item_image_blank': 'iyb8x8granitebrick.png'
            }
        ],
        'frs-black-granite-brick-12x12': [
            {
                'description': '12" x 12" BRICK',
                'material': 'FRS BLACK GRANITE',
                'ui_classes': ['paver', 'p8x8', 'p12x12blackgranite'],
                'max_characters': 16,
                'max_lines': 10,
                'item_image_blank': 'iyb12x12granitebrick.png'
            }
        ],
        'red-blend-tile': [
            {
                'description': '3 5/8" x 7 5/8" TILE',
                'material': 'RED BLEND',
                'ui_classes': ['tile', 't4x8redblend'],
                'max_characters': 16,
                'max_lines': 3,
                'item_image_blank': 'iyb4x8redblendtile.png'
            },
            {
                'description': '7 5/8" x 7 5/8" TILE',
                'material': 'RED BLEND',
                'ui_classes': ['tile', 't8x8redblend'],
                'max_characters': 16,
                'max_lines': 6,
                'item_image_blank': 'iyb8x8redblendtile.png'
            }
        ],
        'medium-ironspot-tile': [
            {
                'description': '3 5/8" x 7 5/8" TILE',
                'material': 'MEDIUM IRONSPOT',
                'ui_classes': ['tile', 't4x8ironspot'],
                'max_characters': 16,
                'max_lines': 3,
                'item_image_blank': 'iyb4x8medirontile.png'
            },
            {
                'description': '7 5/8" x 7 5/8" TILE',
                'material': 'MEDIUM IRONSPOT',
                'ui_classes': ['tile', 't8x8ironspot'],
                'max_characters': 16,
                'max_lines': 6,
                'item_image_blank': 'iyb8x8medirontile.png'
            }
        ],
        'manganese-tile': [
            {
                'description': '3 5/8" x 7 5/8" TILE',
                'material': 'MANGANESE',
                'ui_classes': ['tile', 't4x8manganese'],
                'max_characters': 16,
                'max_lines': 3,
                'item_image_blank': 'iyb4x8manganesetile.png'
            },
            {
                'description': '7 5/8" x 7 5/8" TILE',
                'material': 'MANGANESE',
                'ui_classes': ['tile', 't8x8manganese'],
                'max_characters': 16,
                'max_lines': 6,
                'item_image_blank': 'iyb8x8manganesetile.png'
            }
        ],
        'absolute-black-granite-tile': [
            {
                'description': '12" x 12" TILE',
                'material': 'ABSOLUTE BLACK GRANITE',
                'ui_classes': ['tile', 't12x12blackgranite'],
                'max_characters': 20,
                'max_lines': 10,
                'item_image_blank': 'iyb12x12granitetile.png'
            }
        ]
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js